import {
  createClient,
  DeleteOperation,
  deleteRequestFactory,
  FindOperation,
  getRequestFactory,
  putRequestFactory,
  SaveOperation,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';

export enum InstallerCompanyStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED'
}

export const getInstallerCompanyStatusVarient = (status: InstallerCompanyStatus) => {
  switch (status) {
    case InstallerCompanyStatus.APPROVED:
      return 'success';
    case InstallerCompanyStatus.REJECTED:
      return 'error';
    default:
      return 'neutral';
  }
};

export interface InstallerCompany {
  id: number;
  name: string;
  type: string;
  size: string;
  address: string;
  country: string;
  locale: string;
  signupName: string;
  signupEmail: string;
  description: string;
  status: InstallerCompanyStatus;
  rejectedReason?: string;
  createdAt: Date;
  updatedAt: Date;
  acceptMarketingContent?: boolean;
}

export interface AcceptCompany {
  iamOrganisationId: string;
}

const client = createClient('/rest/installer/company');

export const installerCompanyPermissions = {
  SEARCH: 'cpms.search-companies',
  GET: 'cpms.get-company',
  ACCEPT: 'cpms.accept-company',
  REJECT: 'cpms.reject-company',
  DELETE: 'cpms.delete-company'
};

export const searchCompanies: SearchOperation<InstallerCompany> = searchRequestFactory<InstallerCompany>(client, {
  permissionId: installerCompanyPermissions.SEARCH
});

export const getCompany: FindOperation<InstallerCompany, string> = getRequestFactory<InstallerCompany, string>(client, {
  permissionId: installerCompanyPermissions.GET
});

export const acceptInstallerCompany: SaveOperation<AcceptCompany, never> = putRequestFactory<AcceptCompany, never>(
  client,
  {
    pattern: '/{companyId}/accept',
    permissionId: installerCompanyPermissions.ACCEPT
  }
);

export const rejectInstallerCompany: SaveOperation<Pick<InstallerCompany, 'rejectedReason'>, never> = putRequestFactory<
  Pick<InstallerCompany, 'rejectedReason'>,
  never
>(client, { pattern: '/{companyId}/reject', permissionId: installerCompanyPermissions.REJECT });

export const deleteInstallerCompany: DeleteOperation<never> = deleteRequestFactory<never>(client, {
  pattern: '/{companyId}',
  permissionId: installerCompanyPermissions.DELETE
});
